import axios from "axios";
import { SessionInfo } from "redmond";
import { platformApiApi } from "@capone/platform-api";

import { config } from "../../config";

export const fetchUserInfo = async (): Promise<SessionInfo> => {
  const res = await platformApiApi(axios).apiV0UserInfoGet({
    baseURL: config.baseURL,
  });

  return res.data as SessionInfo;
};
